// src/pages/Admin/VotePage/ui/VoteStatCard.jsx

import React from "react";

export default function VoteStatCard({
  icon: Icon,
  title,
  value,
  hint,
  variant = "blue",
}) {
  const variants = {
    blue: {
      icon: "bg-blue-50 text-blue-600 dark:bg-blue-500/10 dark:text-blue-300",
      border:
        "hover:border-blue-200 dark:hover:border-blue-500/30",
    },

    emerald: {
      icon: "bg-emerald-50 text-emerald-600 dark:bg-emerald-500/10 dark:text-emerald-300",
      border:
        "hover:border-emerald-200 dark:hover:border-emerald-500/30",
    },

    amber: {
      icon: "bg-amber-50 text-amber-600 dark:bg-amber-500/10 dark:text-amber-300",
      border:
        "hover:border-amber-200 dark:hover:border-amber-500/30",
    },

    violet: {
      icon: "bg-violet-50 text-violet-600 dark:bg-violet-500/10 dark:text-violet-300",
      border:
        "hover:border-violet-200 dark:hover:border-violet-500/30",
    },
  };

  const configuration =
    variants[variant] || variants.blue;

  return (
    <article
      className={`rounded-2xl border border-slate-200 bg-white p-4 shadow-sm transition duration-300 hover:-translate-y-0.5 hover:shadow-lg dark:border-slate-700 dark:bg-slate-900 ${configuration.border}`}
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="text-[11px] font-black uppercase tracking-[0.12em] text-slate-400">
            {title}
          </div>

          <div className="mt-2 text-3xl font-black tracking-tight text-slate-950 dark:text-white">
            {value}
          </div>
        </div>

        <div
          className={`flex h-11 w-11 items-center justify-center rounded-2xl ${configuration.icon}`}
        >
          <Icon className="text-lg" />
        </div>
      </div>

      {hint && (
        <p className="mt-2 text-xs leading-relaxed text-slate-500 dark:text-slate-400">
          {hint}
        </p>
      )}
    </article>
  );
}